export default __webpack_public_path__ + "static/media/mask2.12acaf6e.png";